import Cookies from 'js-cookie';


export default class CookiesJS {

    constructor() {
        this.cookies_possible_name = 'CookieScriptConsent';
    }

    setCookie(cname, cvalue, exdays) {
        let cdomain = '.' + window.location.hostname;
        Cookies.set(cname, cvalue, {
            expires: exdays,
            path: '/',
            domain: cdomain,
            secure: true,
            sameSite: 'lax'
        })
    }


    delete_cookie(name) {
        let cdomain = '.' + window.location.hostname;
        Cookies.remove(name, {
            path: '/',
            domain: cdomain
        });
        Cookies.remove(name, {
            path: '/',
            domain: window.location.hostname
        });
        Cookies.remove(name, {
            path: '/'
        });
    }


    getCookie(cname) {
        return Cookies.get(cname);
    }


    check_cookies_is_possible() {
        if (window.location.hostname === 'join.com') {
            let is_cookies_possible = this.getCookie(this.cookies_possible_name);
            if (!is_cookies_possible || is_cookies_possible.length < 5) {
                return null;
            }
            let data = JSON.parse(is_cookies_possible);
            if (data.action == 'accept' && data.categories.includes('functionality')) {
                return true;
            }
            return false;
        }
        if (window.location.hostname === 'join-staging.com') {
            let is_cookies_possible = this.getCookie(this.cookies_possible_name);
            if (!is_cookies_possible || is_cookies_possible.length < 5) {
                return null;
            }
            let data = JSON.parse(is_cookies_possible);
            if (data.action == 'accept' && data.categories.includes('functionality')) {
                return true;
            }
            return false;
        }
        return true;
    }
}
